import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

/**
 * Specification of the fade duration given in milliseconds.
 */
const DURATION = 250;

/**
 * Css fade transition that'll fade the throbber out of view as needed.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const TextFade: React.FC<{ in?: boolean; children: React.ReactNode }> = (
  props
) => {
  const ref = useRef<HTMLSpanElement>(null);

  return (
    <CSSTransition
      {...props}
      classNames="richtext__textFade"
      timeout={DURATION}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
    >
      <span ref={ref}>
        {props.children}

        <style jsx global>{`
          .richtext__textFade-enter {
            /** Force the element to overlap */
            position: relative;
            z-index: 1;

            /** Prepare fade-in */
            opacity: 0.001;
          }

          .richtext__textFade-enter-active {
            opacity: 1;
            transition: opacity ${DURATION}ms linear;
          }

          .richtext__textFade-exit {
            /** Underlap the block */
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;

            /** Preapre fade-out */
            opacity: 1;
          }

          .richtext__textFade-exit-active {
            opacity: 0.001;
            transition: opacity ${DURATION}ms linear;
          }
        `}</style>
      </span>
    </CSSTransition>
  );
};
